<template>
  <div class="container">
    <loading-wrap :loading="loading">
      <div class="row justify-content-center pt-5">
        <div class="col-8">
          <h5>Pending Assessments</h5>
          <template v-if="pending.length">
            <assessment-card v-for="a in pending" :assessment="a" :key="a._id"/>
          </template>
          <no-results v-else/>
          <hr>
          <h5>Completed Assessments</h5>
          <template v-if="completed.length">
            <assessment-card v-for="a in completed" :assessment="a" :key="a._id"/>
          </template>
          <no-results v-else/>
        </div>
      </div>
    </loading-wrap>
  </div>
</template>

<script>
export default {
  data() {
    return {
      completed: [],
      pending: [],
      loading: true
    };
  },
  created() {
    this.axios.get("/api/assessments").then(res => {
      this.completed = res.data.filter(a => a.tutorSubmittedAt);
      this.pending = res.data.filter(a => !a.tutorSubmittedAt);
      this.loading = false;
    });
  }
};
</script>

